module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/chicken-btn-audio-english.b7d0a408.png";